/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 FormControlLabel, NS/Tractie composite-label-pendant overrides.
// Tractie source: composite (label + control). Checkbox, radio and toggle use
// column-gap --tractie-spacing-spacer-2 (8px) between control and label. The label
// is 0.875rem, font-weight 700, color --tractie-color-content-emphasis.
//
// FormControlLabel wraps Checkbox/Radio/Switch + label-text. Tractie heeft geen
// directe MUI-equivalent voor deze composite, maar de label-styling-eisen volgen
// uit Tractie label-spec: bold (700), 0.875rem, --tractie-color-content-emphasis.
//
// Token references (Tractie -> NS):
//   - column-gap control-label: --tractie-spacing-spacer-2 (8px) -> --ns-space-2 (cluster 6)
//   - label color: --tractie-color-content-emphasis -> --ns-color-fg-emphasis (cluster 2)
//   - label font-size: 0.875rem -> --ns-font-size-s (cluster 7)
//   - label font-weight: 700 -> 700 (Tractie label spec line 441)
//   - disabled color: --tractie-color-fg-disabled-equivalent -> opacity 0.5 (consistent met checkbox/radio root)
//
// MUI v4 FormControlLabel DOM:
//   <label class="MuiFormControlLabel-root">
//     <Checkbox/Radio/Switch />
//     <span class="MuiFormControlLabel-label">{label}</span>
//   </label>
//
// MUI defaults that Tractie deviates from:
//   - margin: -11px (right) -16px (left) compensating control padding -> Tractie: 0 (gap is space-2)
//   - label color: text.primary (#000 ~) -> --ns-color-fg-emphasis (Tractie label-color)
//   - label font: inherits theme.typography.body1 -> --ns-font-size-s + 700 weight (Tractie)

export const MuiFormControlLabelLightOverrides = {
  root: {
    marginLeft: 0,
    marginRight: 0,
    // Column-gap tussen control en label-text via space-2 (Tractie spec).
    // MUI plaatst control direct naast label zonder gap; Tractie heeft 8px gap.
    gap: 'var(--ns-space-2)',
    '&$disabled': {
      cursor: 'default' as const,
      opacity: 0.5,
    },
  },

  label: {
    color: 'var(--ns-color-fg-emphasis)',
    fontSize: 'var(--ns-font-size-s)',
    fontWeight: 700,
    lineHeight: 1.5,
    '&$disabled': {
      color: 'var(--ns-color-fg-emphasis)',
      opacity: 0.5,
    },
  },

  disabled: {},
} as const;

// Dark spreads Light: token-driven (fg-emphasis mode-flipt via tokens.css).
export const MuiFormControlLabelDarkOverrides = {
  ...MuiFormControlLabelLightOverrides,
} as const;
